/* eslint-disable no-unused-vars */
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { APIEventSystem } from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export enum GameEvents {
    UPDATE_GAME_MODE = `UPDATE_GAME_MODE`,
    UPDATE_FS_MULTIPLIER = `UPDATE_FS_MULTIPLIER`,
    UPDATE_MULTIPLIER_PROGRESSION = `UPDATE_FS_PROGRESSION`,
    ON_XWAYS_BUTTON_CLICK = `ON_XWAYS_BUTTON_CLICK`,
    SHOW_XBET_BUTTON = `SHOW_XBET_BUTTON`,
    HIDE_XBET_BUTTON = `HIDE_XBET_BUTTON`,
    BLOCK_XBET_BUTTON = `BLOCK_XBET_BUTTON`,
    UNBLOCK_XBET_BUTTON = `UNBLOCK_XBET_BUTTON`,
    SHOW_XBET_FRAME = `SHOW_XBET_FRAME`,
    HIDE_XBET_FRAME = `HIDE_XBET_FRAME`,
    CHECK_XBET_ON_RESTORE = `CHECK_XBET_ON_RESTORE`,
    ENABLE_IDLE_ANIMATIONS = `START_IDLE_ANIMATIONS`,
    DISABLE_IDLE_ANIMATIONS = `DISABLE_IDLE_ANIMATIONS`,
    ON_FREE_BETS_START = `ON_FREE_BETS_START`,
    ON_FREE_BETS_END = `ON_FREE_BETS_END`,
}

export enum ReelsEvents {
    GET_REELS = `GET_REELS`,
    GET_NORMAL_REELS = `GET_NORMAL_REELS`,
    GET_BOTTOM_REEL = `GET_BOTTOM_REELS`,
    GET_FREESPIN_REELS = `GET_FREESPIN_REELS`,
    GET_FREESPIN_BOTTOM_REEL = `GET_FREESPIN_BOTTOM_REEL`,
    GET_FREESPIN_COUNTER = `GET_FREESPIN_COUNTER`,
    GET_FREESPIN_MULTIPLIER = `GET_FREESPIN_MULTIPLIER`,
    GET_REELS_VIEW = `GET_REELS_VIEW`,
}

export enum WinEvents {
    GET_WINNINGS_VIEW = `GET_WINNINGS_VIEW`,
}

export enum FlowEvents {
    BET_STARTED = `BET_STARTED`,
    SKIP_NORMAL_BET = `SKIP_NORMAL_BET`,
    SKIP_AVALANCHE_BET = `SKIP_AVALANCHE_BET`,
    SKIP_FREESPIN_BET = `SKIP_FREESPIN_BET`,
}

export enum SoundEvents {
    PLAY_SOUND = `PLAY_SOUND`,
    PLAY_SOUND_ONCE = `PLAY_SOUND_ONCE`,
    STOP_SOUND = `STOP_SOUND`,
    PLAY_BACKGROUND_MUSIC = `PLAY_BACKGROUND_MUSIC`,
    STOP_BACKGROUND_MUSIC = `STOP_BACKGROUND_MUSIC`,
    FADE_OUT_BACKGROUND_MUSIC = `FADE_OUT_BACKGROUND_MUSIC`,
    FADE_IN_BACKGROUND_MUSIC = `FADE_IN_BACKGROUND_MUSIC`,
    FADE_IN_SOUND = `FADE_IN_SOUND`,
    FADE_OUT_SOUND = `FADE_OUT_SOUND`,
    FADE_SOUND = `FADE_SOUND`,
    FADE_AND_STOP_SOUND = `FADE_AND_STOP_SOUND`,
    START_AMBIANCE_SOUNDS = `START_AMBIANCE_SOUNDS`,
    STOP_AMBIANCE_SOUNDS = `STOP_AMBIANCE_SOUNDS`,
}

export enum BackgroundEvents {
    SHOW_NEXT_BACKGROUND = `SHOW_NEXT_BACKGROUND`,
    GET_LOGO = `GET_LOGO`,
    GET_BACKGROUND_VIEW = `GET_BACKGROUND_VIEW`,
}

class CustomEvents {
    private static instance: CustomEvents;
    private events: APIEventSystem;

    constructor() {
        this.events = SlotGame.apiPlugin.eventSystemFactory.create();
    }

    public static getInstance(): CustomEvents {
        if (!CustomEvents.instance) {
            CustomEvents.instance = new CustomEvents();
        }

        return CustomEvents.instance;
    }

    public on(event: string, callback: Function): void {
        this.events.on(event, callback);
    }

    public trigger(event: string, data?: any): void {
        this.events.trigger(event, data);
    }
}

export class EventsManager {
    public static on(event: string, callback: Function): void {
        CustomEvents.getInstance().on(event, callback);
    }

    public static trigger(event: string, data?: any): void {
        CustomEvents.getInstance().trigger(event, data);
    }
}
